<script setup lang='ts'>
import { APP_ROUTER } from '@qctsw/common'
import { timeFrom } from '@qctsw/utils'
import type { ComplaintDetailResponse } from '~/server/types'

const props = withDefaults(defineProps<{
  moreLs?: ComplaintDetailResponse['moreLs']
  vendorName?: string
  brandName?: string
  seriesName?: string
  modelName?: string
}>(), {
  moreLs: () => [],
})
</script>

<template>
  <div v-if="props.moreLs && props.moreLs.length">
    <div class="flex items-center justify-between font-bold bg-slate-2 px-4 min-h-11 ">
      <div class="w-27.5">
        多次投诉列表
      </div>
      <div class="text-red-5 flex-grow min-w-0 text-right">
        累计针对{{
          [props.vendorName ?? props.brandName,
           props.seriesName, props.modelName].join('-')
        }}投诉共计{{ props.moreLs.length }}次
      </div>
      <!-- 最新 -->
    </div>
    <div class="collective-lis">
      <NuxtLink
        v-for="(v, i) in props.moreLs" :key="i"
        :to="APP_ROUTER.complaintDetail(v.complainId)"
        class="flex items-center overflow-hidden py-3 px-4 border-b-1 border-slate-1"
      >
        <div class="w-27.5 mr-xl flex-shrink-0">
          QT{{ v.complainId }}
        </div>
        <div class="line-clamp-1 flex-grow min-w-0 overflow-hidden">
          {{ v.title }}
        </div>
        <div class="flex-shrink-0 text-right  ml-xl">
          {{ timeFrom(v.createTime) }}
        </div>
      </NuxtLink>
    </div>
  </div>
</template>

<style lang='scss' scoped>

</style>
